module.exports = __webpack_public_path__ + "img/company.d5fd32fd.svg";